import { Injectable } from '@angular/core';
import { FrappeApp, FrappeCall } from 'frappe-js-sdk';
import { AppConstant } from '../../app.constant';

@Injectable({
    providedIn: 'root'
})
export class GateOutService {

    private frappe: FrappeApp;
    private frappeCall: FrappeCall;
    constructor() {
        this.frappe = new FrappeApp(AppConstant.frappeUrl);
        this.frappeCall = this.frappe.call()
    }

    public getAllGateInUnloading(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.get_out.get_gate_in_unloading_detail');
    }
    public getAllVisitorPassDetail(): Promise<any> {
        return this.frappe.call().get('vendor_portal.api.get_out.get_all_visitor_pass_no');
    }

    public getSelectedGateInData(name: any): Promise<any> {
        const requestBody = { name: name };
        return this.frappeCall.get('vendor_portal.api.get_out.get_gate_entry_detail', requestBody);
    }

    public createGateOut(createGateOutData: any) {
        return this.frappeCall.post('vendor_portal.api.get_out.create_gate_out', { data: JSON.stringify(createGateOutData) })
    }

}
